import { RestClient } from '@affstore-ds/restclient'

import { TrackerTypesApiPaths, TrackerTypesOperations } from '../../types'

export const getApiTrackerAffiliate = (
  query: TrackerTypesOperations['GetApiTrackerAffiliate']['parameters']['query'],
  apiDomain: string,
) => {
  const client = new RestClient(TrackerTypesApiPaths.GetApiTrackerAffiliate, {}, apiDomain, {
    mode: 'cors',
    referrerPolicy: 'no-referrer',
  })

  return client.get<unknown>('', query)
}
